import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TraderQuizShell from './TraderQuizShell';
import QuizResults from '../components/Quiz/QuizResults';
import '../components/Quiz/Quiz.css';

const getBackendBase = () => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const TraderQuizSavedResult = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const base = getBackendBase();
      if (!base) {
        setError('This page needs the app backend to load saved results.');
        setLoading(false);
        return;
      }
      if (!token || !/^[a-f0-9]{64}$/i.test(token)) {
        setError('Invalid link.');
        setLoading(false);
        return;
      }
      try {
        const res = await fetch(`${base}/trader-quiz/submissions/${token}`);
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data.error || 'Not found');
        }
        if (!cancelled) {
          setPayload(data);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e.message || 'Could not load results.');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const onRetake = useCallback(() => {
    navigate('/quiz', { replace: true });
  }, [navigate]);

  return (
    <TraderQuizShell>
      <div className="quiz-shell mx-auto px-3 px-md-4 py-4" style={{ maxWidth: 960 }}>
        {loading ? (
          <div className="text-muted small py-5 text-center">Loading your results…</div>
        ) : error ? (
          <div className="text-center py-5">
            <p className="text-light mb-3">{error}</p>
            <button type="button" className="btn btn-primary" onClick={() => navigate('/quiz')}>
              Take the FREE Quiz
            </button>
          </div>
        ) : payload?.result ? (
          <QuizResults result={payload.result} traderSegment={payload.traderSegment} onRetake={onRetake} />
        ) : null}
      </div>
    </TraderQuizShell>
  );
};

export default TraderQuizSavedResult;
